import React, { useEffect, useState } from "react";
import { showToast } from "../../../Components/Utlis/toastUtlis";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'


const Roomavailability = () => {

    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [rooms, setRooms] = useState("1");
    const [guests, setGuests] = useState("1");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer); 
    }, []);

    useEffect(() => {
        localStorage.setItem("checkIn", checkIn);
        localStorage.setItem("checkOut", checkOut);
        localStorage.setItem("rooms", rooms);
        localStorage.setItem("guests", guests);
    }, [checkIn, checkOut, rooms, guests]);

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Loading started");

        if (!checkIn) {
            showToast("error", "Please select check-in date");
            return false;
        }

        if (!checkOut) {
            showToast("error", "Please select check-out date");
            return false;
        }

        if (new Date(checkOut) <= new Date(checkIn)) {
            showToast("error", "Check-out date must be later than check-in date.");
            return false;
        }

        // showToast("success", "Redirecting to available rooms...");

        navigate(`/available-rooms?checkin=${checkIn}&checkout=${checkOut}&rooms=${rooms}&guests=${guests}`);

        
    };

    return (
        <>
            {loading ? (
                <div className="container-fluid booking pb-5" id="booking">
                    <div className="container">
                        <div className="bg-white shadow" style={{ padding: 35 }}>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-2">
                                    <div className="col-md-10">

                                        <div className="row g-2">
                                            <div className="col-md-3">
                                                <div className="date">
                                                    <Skeleton width={120} height={30}/>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="date">
                                                    <Skeleton width={120} height={30}/>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <Skeleton width={120} height={30}/>
                                            </div>
                                            <div className="col-md-3">
                                                <Skeleton width={120} height={30}/>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-2">
                                        <button type="submit" 
                                            className="btn  w-100">
                                             <Skeleton width={120} height={30}/>

                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            ) : (
                <div className="container-fluid booking pb-5" id="booking">
                    <div className="container">
                        <div className="bg-white shadow" style={{ padding: 35 }}>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-2">
                                    <div className="col-md-10">

                                        <div className="row g-2">
                                            <div className="col-md-3">
                                                <div className="date">
                                                    <label style={{ color: "black", fontWeight: "600", marginLeft: "10px" }} className="text-center mb-2">Check In</label>
                                                    <input type="date"
                                                        className="form-control"
                                                        name="checkIn"
                                                        placeholder="Check in"
                                                        value={checkIn}
                                                        onChange={(e) => setCheckIn(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="date">
                                                    <label style={{ color: "black", fontWeight: "600", marginLeft: "10px" }} className="text-center mb-2">Check Out</label>
                                                    <input type="date"
                                                        className="form-control"
                                                        placeholder="Check out"
                                                        value={checkOut}
                                                        onChange={(e) => setCheckOut(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label style={{ color: "black", fontWeight: "600", marginLeft: "10px" }} className="text- mb-2">Rooms</label>
                                                <select className="form-select" value={rooms} onChange={(e) => setRooms(e.target.value)}>
                                                    <option selected>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                    <option value={4}>5</option>

                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label style={{ color: "black", fontWeight: "600", marginLeft: "10px" }} className="text-center mb-2">Guest</label>
                                                <select className="form-select" value={guests} onChange={(e) => setGuests(e.target.value)}>
                                                    <option selected>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                    <option value={5}>5</option>
                                                    <option value="More than 5">More than 5</option>

                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-2">
                                        <button type="submit" style={{ marginTop: "30px" }}
                                            className="btn btn-primary w-100" disabled={loading}>
                                            {loading ? "Loading..." : "Book Now"}

                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            )}

        </>
    )
}

export default Roomavailability
